import { useId } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const ResultsDialogGraphic = svgProps => {
  const id = useId();
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 226 158",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 158),
    ...svgProps,
    fill: "none",
    children: [/*#__PURE__*/jsx("path", {
      d: "M226 81.4772C226 123.74 175.408 158 113 158 50.5918 158 0 123.74 0 81.4772 0 39.2149 23.5417-17.1105 113 4.9544c82.396 20.323 113 34.2605 113 76.5228Z",
      fill: "#090B19",
      fillOpacity: ".03"
    }), /*#__PURE__*/jsx("g", {
      filter: `url(#${id}-a)`,
      children: /*#__PURE__*/jsx("rect", {
        x: "33",
        y: "12",
        width: "160",
        height: "110",
        rx: "2",
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("circle", {
      cx: "80.5",
      cy: "68.5",
      r: "23.5",
      stroke: "#59A000",
      strokeWidth: "8"
    }), /*#__PURE__*/jsx("path", {
      d: "M80.75 45c12.9787 0 23.5 10.5213 23.5 23.5",
      stroke: "#D90101",
      strokeWidth: "8"
    }), /*#__PURE__*/jsx("path", {
      fill: "#D9D9D9",
      d: "M122 72h34v4h-34zM122 90h34v4h-34zM122 54h34v4h-34zM122 37h34v4h-34z"
    }), /*#__PURE__*/jsx("path", {
      d: "M73.2452 65.82c0-1.88 1.36-3.36 3.46-3.36 2.14 0 3.52 1.48 3.52 3.36 0 1.86-1.38 3.32-3.52 3.32-2.1 0-3.46-1.46-3.46-3.32Zm2.14 10.18 8.52-13.34h1.74L77.1052 76h-1.72Zm2.7-10.18c0-1-.6-1.52-1.38-1.52-.76 0-1.34.52-1.34 1.52 0 .96.58 1.48 1.34 1.48.78 0 1.38-.52 1.38-1.48Zm2.7 7.1c0-1.88 1.36-3.36 3.46-3.36 2.12 0 3.5 1.48 3.5 3.36 0 1.86-1.38 3.32-3.5 3.32-2.1 0-3.46-1.46-3.46-3.32Zm4.84 0c0-1-.6-1.52-1.38-1.52-.78 0-1.34.52-1.34 1.52 0 .98.56 1.48 1.34 1.48s1.38-.5 1.38-1.48Z",
      fill: "#000"
    }), /*#__PURE__*/jsx("path", {
      stroke: "#000",
      d: "M80.5 38v14M112 68.5H97"
    }), /*#__PURE__*/jsx("circle", {
      cx: "173.5",
      cy: "37.5",
      r: "4.875",
      fill: "#59A000"
    }), /*#__PURE__*/jsx("path", {
      d: "m171.117 37.8933 1.656 1.6378 2.921-3.5208",
      stroke: "#fff",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("circle", {
      cx: "173.5",
      cy: "73.5",
      r: "4.875",
      fill: "#59A000"
    }), /*#__PURE__*/jsx("path", {
      d: "m171.117 73.8933 1.656 1.6378 2.921-3.5208",
      stroke: "#fff",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("circle", {
      cx: "173.5",
      cy: "91.5",
      r: "4.875",
      fill: "#59A000"
    }), /*#__PURE__*/jsx("path", {
      d: "m171.117 91.8933 1.656 1.6378 2.921-3.5208",
      stroke: "#fff",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("circle", {
      cx: "173.5",
      cy: "55.5",
      r: "4.875",
      fill: "#D90101"
    }), /*#__PURE__*/jsx("path", {
      d: "m171.333 53.3335 4.334 4.3333M171.333 57.6665l4.334-4.3333",
      stroke: "#fff",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsxs("filter", {
        id: `${id}-a`,
        x: "23",
        y: "2",
        width: "180",
        height: "130",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {}), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0.0352941 0 0 0 0 0.0431373 0 0 0 0 0.0980392 0 0 0 0.1 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_2168_5286"
        }), /*#__PURE__*/jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_2168_5286",
          result: "shape"
        })]
      })
    })]
  });
};

export { ResultsDialogGraphic };
//# sourceMappingURL=dialog.results.js.map
